/* Halvari product page: variant options, price, availability, gallery counter and sticky bar.
   Vanilla JS. The form still works without it: it simply adds the first available variant. */
(function () {
  'use strict';

  function qs(root, selector) {
    return root.querySelector(selector);
  }

  function qsa(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function variantOptions(variant) {
    if (Array.isArray(variant.options)) return variant.options;
    var list = [];
    if (variant.option1 != null) list.push(variant.option1);
    if (variant.option2 != null) list.push(variant.option2);
    if (variant.option3 != null) list.push(variant.option3);
    return list;
  }

  function findVariant(variants, selected) {
    for (var i = 0; i < variants.length; i++) {
      var options = variantOptions(variants[i]);
      if (options.length !== selected.length) continue;
      var match = true;
      for (var j = 0; j < options.length; j++) {
        if (options[j] !== selected[j]) {
          match = false;
          break;
        }
      }
      if (match) return variants[i];
    }
    return null;
  }

  function initVariants(root, variants) {
    var idInput = qs(root, '[data-variant-id]');
    var groups = qsa(root, '[data-option]');
    var priceNodes = qsa(root, '[data-variant-price]');
    var buttons = qsa(root, '[data-atc]');
    var checkout = qs(root, '[data-checkout]');
    var stickyPrice = qs(root, '[data-sticky-price]');

    function selectedOptions() {
      return groups.map(function (group) {
        var checked = qs(group, 'input:checked');
        return checked ? checked.value : null;
      });
    }

    function setPrice(variant) {
      var shownText = '';
      priceNodes.forEach(function (node) {
        var show = !!variant && node.getAttribute('data-variant-price') === String(variant.id);
        node.hidden = !show;
        if (show) {
          var value = qs(node, '[data-price-value]') || node;
          shownText = value.textContent.trim();
        }
      });
      if (stickyPrice && shownText) stickyPrice.textContent = shownText;
    }

    function setButtons(variant) {
      var purchasable = !!variant && !!variant.available;
      buttons.forEach(function (button) {
        var label = qs(button, '[data-add-label]');
        var key = 'data-label-add';
        if (!variant) key = 'data-label-unavailable';
        else if (!variant.available) key = 'data-label-sold-out';
        button.disabled = !purchasable;
        if (label) label.textContent = button.getAttribute(key) || label.textContent;
      });
      if (checkout) checkout.hidden = !purchasable;
    }

    function setUrl(variant) {
      if (!variant || !window.history || !window.history.replaceState) return;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (error) {
        /* ignore: the URL is a convenience only */
      }
    }

    function showVariantImage(variant) {
      if (!variant || !variant.featured_media || variant.featured_media.id == null) return;
      var item = qs(root, '[data-media-id="' + variant.featured_media.id + '"]');
      if (!item || !item.scrollIntoView) return;
      item.scrollIntoView({
        behavior: prefersReducedMotion() ? 'auto' : 'smooth',
        block: 'nearest',
        inline: 'start'
      });
    }

    function update(userChanged) {
      var variant = findVariant(variants, selectedOptions());
      if (variant && idInput) idInput.value = variant.id;
      setPrice(variant);
      setButtons(variant);
      if (userChanged) {
        setUrl(variant);
        showVariantImage(variant);
      }
    }

    root.addEventListener('change', function (event) {
      var target = event.target;
      if (target && target.matches && target.matches('[data-option-input]')) update(true);
    });

    if (groups.length) update(false);
  }

  function initGallery(root) {
    var list = qs(root, '[data-gallery-list]');
    var counter = qs(root, '[data-gallery-counter]');
    if (!list || !counter) return;
    var items = qsa(list, '.gallery__item');
    var ticking = false;

    function update() {
      if (!items.length) return;
      var width = list.clientWidth;
      var index = width ? Math.round(list.scrollLeft / width) : 0;
      index = Math.max(0, Math.min(items.length - 1, index));
      counter.textContent = items.length > 1 ? index + 1 + ' / ' + items.length : '';
    }

    list.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          update();
        });
      },
      { passive: true }
    );

    update();
  }

  function initSticky(root) {
    var bar = qs(root, '[data-sticky-atc]');
    var mainButton = qs(root, '[data-main-atc]');
    if (!bar || !mainButton || !('IntersectionObserver' in window)) return;

    var mainVisible = true;
    var footerVisible = false;

    function apply() {
      bar.classList.toggle('is-visible', !mainVisible && !footerVisible);
    }

    new IntersectionObserver(function (entries) {
      mainVisible = entries[entries.length - 1].isIntersecting;
      apply();
    }).observe(mainButton);

    var footer = document.querySelector('footer');
    if (footer) {
      new IntersectionObserver(function (entries) {
        footerVisible = entries[entries.length - 1].isIntersecting;
        apply();
      }).observe(footer);
    }
  }

  function init(root) {
    if (!root || root.getAttribute('data-product-ready') === 'true') return;
    var json = qs(root, '[data-product-json]');
    var variants = [];
    if (json) {
      try {
        variants = JSON.parse(json.textContent);
      } catch (error) {
        variants = [];
      }
    }
    root.setAttribute('data-product-ready', 'true');
    initVariants(root, variants);
    initGallery(root);
    initSticky(root);
  }

  function initAll() {
    qsa(document, '[data-product-root]').forEach(init);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector ? event.target.querySelector('[data-product-root]') : null;
    if (root) init(root);
  });
})();
